import { DESTINATION_FILTER, DESTINATION_PORT, DESTINATION_REGION, SHIP_FILTER } from 'components/CruiseSearchWidget/constants';
import { CustomFilterSectionType } from 'components/CruiseSearchWidget/types';
import { Tabs } from 'components/FiltersModal/Tabs/Tabs';
import { useTabs } from 'components/FiltersModal/Tabs/useTabs';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { useAppContext } from 'contexts/appContext';
import { ListFilter, ListFilterOption } from 'lib/apiClient';
import { useCallback, useMemo } from 'react';
import { CustomFilter } from '../../CustomFilter/CustomFilter';
import { FilterOptions } from '../../FilterOptions/FilterOptions';
import { PortsList } from './PortsList/PortsList';

export function FilterList() {
	const { filters, activeFilter, enableUniqueFilters, featureFlags } = useFiltersContext();
	const { dictionary } = useAppContext();
	const { tabsOptions, activeTab, setActiveTab } = useTabs();

	const subTitleLabel = useMemo(() => {
		if (tabsOptions && activeTab?.dictionarySubLabel) {
			return dictionary[activeTab.dictionarySubLabel];
		}
		return activeFilter?.dictionarySubLabel ? dictionary[activeFilter.dictionarySubLabel] : '';
	}, [activeFilter?.dictionarySubLabel, dictionary, tabsOptions, activeTab]);

	const filterOptions = useMemo<ListFilterOption[]>(() => {
		if (tabsOptions) {
			if (activeTab?.value === DESTINATION_REGION) {
				return (filters.find((filter) => filter.key === DESTINATION_FILTER.key) as ListFilter)?.options;
			}
			if (activeTab?.value === DESTINATION_PORT) {
				return (filters.find((filter) => filter.key === DESTINATION_PORT) as ListFilter)?.options;
			}
		}
		return (filters?.find((filter) => filter.key === activeFilter?.key) as ListFilter)?.options;
	}, [filters, activeFilter?.key, tabsOptions, activeTab?.value]);

	const renderCustomFilter = useCallback(
		(sectionsToRender: CustomFilterSectionType[] | undefined = undefined) => {
			if (enableUniqueFilters && (activeTab?.value === DESTINATION_REGION || activeFilter?.key === SHIP_FILTER.key)) {
				return <CustomFilter sectionsToRender={sectionsToRender} />;
			}

			return <></>;
		},
		[enableUniqueFilters, activeTab?.value, activeFilter?.key],
	);

	const renderComponent = useCallback(() => {
		if (activeFilter?.key === DESTINATION_FILTER.key && activeTab?.value === DESTINATION_PORT) {
			return <PortsList filterKey={DESTINATION_PORT} label={subTitleLabel} ports={filterOptions} />;
		}

		if (activeFilter?.key === DESTINATION_FILTER.key && activeTab?.value === DESTINATION_REGION) {
			return (
				<>
					{renderCustomFilter([CustomFilterSectionType.Default])}
					<FilterOptions label={subTitleLabel} options={filterOptions} />
					{featureFlags.enableRiverCruises && renderCustomFilter([CustomFilterSectionType.River])}
				</>
			);
		}

		return (
			<>
				{renderCustomFilter()}
				<FilterOptions label={subTitleLabel} options={filterOptions} />
			</>
		);
	}, [activeTab?.value, activeFilter?.key, subTitleLabel, filterOptions, renderCustomFilter, featureFlags.enableRiverCruises]);

	return (
		<>
			{tabsOptions && activeTab && <Tabs options={tabsOptions} activeTab={activeTab} onTabClicked={setActiveTab} />}
			{renderComponent()}
		</>
	);
}
